// Used by the autoplay countdown instead of window.setInterval because we
// need to hook into these functions and override them in tests.
// We can't use jests mock timers functionality because it causes other side effects
// like having to do jest.runAllTimers() to get fetchMock to work properly.
export default {
    clearInterval(handle: number) {
        window.clearInterval(handle)
    },

    setInterval(handler: (...args: any[]) => void, timeout: number) {
        return window.setInterval(handler, timeout)
    },
}
